import { ConfirmPopupDesignTokens } from '@primeuix/themes/types/confirmpopup';
import { colors } from '../colors';

export const confirmpopup: ConfirmPopupDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        background: colors.blue500,
      },
    },
  },
};
